import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module9Nav = () => {
  const { module9 } = useSelector((state) => state.module9, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage =
      '/Module9Images/Module9NavImages/JourneyMap9-Version2-01.png';
    const mobileImage =
      '/Module9Images/Module9NavImages/JourneyMap9-Mobile.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(event.target),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module9Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+5.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module9Images/Module9NavImages/JourneyMap_Mod4_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module9Images/Module9NavImages/JourneyMap_Mod4_Outline_Day${dayNumber}.png`;

    return {
      dayNumber,
      destiny: '/respond',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/respond/respond_instrumental.m4a',
    slides: [
      `influencers/${login.influencerid}/respond_affirmation.mp4`,
      `userfiles/${module9.StudentID}/respond_celebration_surprise_5.mp4`,
      `influencers/${login.influencerid}/respond_affirmation.mp4`,
      'appfiles/respond/respond_greeting_5.mp4',
      `userfiles/${module9.StudentID}/greet_practice_video_5.mp4`,
      'appfiles/respond/respond_question_5.mp4',
      `userfiles/${module9.StudentID}/answer_practice_video_5.mp4`,
      'appfiles/ask/ask_acknowledge_5.mp4',
      `userfiles/${module9.StudentID}/ask_practice_video_5.mp4`,
      'appfiles/respond/respond_respond_5.mp4',
      `userfiles/${module9.StudentID}/respond_practice_video_5.mp4`,
      `influencers/${login.influencerid}/respond_video_message.mp4`,
      `influencers/${login.influencerid}/respond_affirmation.mp4`,
      `userfiles/${module9.StudentID}/respond_celebration_surprise_9.mp4`,
      `influencers/${login.influencerid}/respond_affirmation.mp4`,
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url, login))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE9'
          module={module9}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit2'
          nextDestiny='/unit2'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={2}
          animal={MediaService.getImage('/Images/Button_monkeyHead.png', login)}
        />
      )}
    </>
  );
};
export default Module9Nav;
